import { useState, useEffect } from 'react';
import API from '../api/axios';

/**
 * Custom hook to fetch active tour categories dynamically from the backend.
 * Returns: { categories: string[], loading: bool, error: string|null }
 */
const useCategories = (includeAll = false) => {
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchCategories = async () => {
      try {
        setLoading(true);
        const { data } = await API.get('/categories?active=1');
        const names = (Array.isArray(data) ? data : []).map((c) => c.name);
        setCategories(includeAll ? ['All', ...names] : names);
      } catch {
        setError('Failed to load categories');
        // Fallback to defaults so app still functions
        const defaults = ['Domestic', 'International', 'Religious', 'Wildlife'];
        setCategories(includeAll ? ['All', ...defaults] : defaults);
      } finally {
        setLoading(false);
      }
    };
    fetchCategories();
  }, [includeAll]);

  return { categories, loading, error };
};

export default useCategories;
